/**
 * Tire results page: fetch /apps/specr/api/tire-results from URL params,
 * render product grid with sidebar filters and sort.
 */
(function () {
  var PROXY = "/apps/specr/api/tire-results";
  var REC_PROXY = "/apps/specr/api/tire-recommendations";
  var TIRE_SEARCH_CONTEXT_KEY = "specr_tire_search_context";
  var TIRE_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/>' +
    "</svg>";

  var TREADWEAR_LABELS = {
    "under-40": "Under 40k",
    "40-60": "40k – 60k",
    "60-80": "60k – 80k",
    "80-plus": "80k+",
  };

  var root = document.getElementById("tire-results");
  if (!root) return;

  function extractRimDiameter(size) {
    if (!size) return "";
    var m = String(size).match(/R([\d.]+)\s*$/i);
    return m ? m[1].replace(/\.0$/, "") : "";
  }

  function parseInstallFeesConfig() {
    var raw = root.getAttribute("data-install-fees");
    if (raw) {
      try {
        var parsed = JSON.parse(raw);
        return {
          mountByRim: parsed.mountByRim || {},
          mountFallback: Number(parsed.mountFallback) || 80,
          disposal: Number(parsed.disposal) || 0,
        };
      } catch (e) {
        /* fall through */
      }
    }
    return {
      mountByRim: {},
      mountFallback: 80,
      disposal: 16,
    };
  }

  var installFeesConfig = parseInstallFeesConfig();

  function resolveMountForTireSize(tireSize) {
    var rim = extractRimDiameter(tireSize || "");
    var mount = installFeesConfig.mountFallback;
    if (rim && installFeesConfig.mountByRim && installFeesConfig.mountByRim[rim] != null) {
      var rimMount = Number(installFeesConfig.mountByRim[rim]);
      if (Number.isFinite(rimMount) && rimMount >= 0) mount = rimMount;
    }
    return mount;
  }

  function computeInstallSubtotal(tireSize) {
    var mount = resolveMountForTireSize(tireSize);
    return mount + (installFeesConfig.disposal || 0);
  }

  function installCaptionForTireSize(tireSize) {
    var total = computeInstallSubtotal(tireSize);
    if (!total || total <= 0) return "";
    return (
      '<p class="tr-card__install">+ install from $' + total.toFixed(0) + "</p>"
    );
  }

  function installCaptionForStaggered(frontVariant, rearVariant) {
    var sizeForEstimate = "";
    var maxRim = 0;
    [frontVariant, rearVariant].forEach(function (v) {
      if (!v || !v.tireSize) return;
      var rim = extractRimDiameter(v.tireSize);
      var rimNum = Number(rim) || 0;
      if (rimNum >= maxRim) {
        maxRim = rimNum;
        sizeForEstimate = v.tireSize;
      }
    });
    return installCaptionForTireSize(sizeForEstimate);
  }

  if (root.getAttribute("data-api")) {
    PROXY = root.getAttribute("data-api");
  }
  if (root.getAttribute("data-recommendations-api")) {
    REC_PROXY = root.getAttribute("data-recommendations-api");
  }

  var contextBanner = document.getElementById("tr-context-banner");
  var curationNoticeEl = document.getElementById("tr-curation-notice");
  var errorEl = document.getElementById("tr-error");
  var loadingEl = document.getElementById("tr-loading");
  var skeletonEl = document.getElementById("tr-skeleton");
  var emptyEl = document.getElementById("tr-empty");
  var gridEl = document.getElementById("tr-grid");
  var resultCountEl = document.getElementById("tr-result-count");
  var sortEl = document.getElementById("tr-sort");
  var brandFiltersEl = document.getElementById("tr-brand-filters");
  var seasonFiltersEl = document.getElementById("tr-season-filters");
  var protectionFiltersEl = document.getElementById("tr-protection-filters");
  var speedFiltersEl = document.getElementById("tr-speed-filters");
  var vehicleTypeFiltersEl = document.getElementById("tr-vehicle-type-filters");
  var loadIndexFiltersEl = document.getElementById("tr-load-index-filters");
  var treadwearFiltersEl = document.getElementById("tr-treadwear-filters");
  var utqgTractionFiltersEl = document.getElementById("tr-utqg-traction-filters");
  var utqgTempFiltersEl = document.getElementById("tr-utqg-temp-filters");
  var brandFieldset = document.getElementById("tr-brand-fieldset");
  var seasonFieldset = document.getElementById("tr-season-fieldset");
  var protectionFieldset = document.getElementById("tr-protection-fieldset");
  var speedFieldset = document.getElementById("tr-speed-fieldset");
  var vehicleTypeFieldset = document.getElementById("tr-vehicle-type-fieldset");
  var loadIndexFieldset = document.getElementById("tr-load-index-fieldset");
  var treadwearFieldset = document.getElementById("tr-treadwear-fieldset");
  var utqgTractionFieldset = document.getElementById("tr-utqg-traction-fieldset");
  var utqgTempFieldset = document.getElementById("tr-utqg-temp-fieldset");
  var priceFieldset = document.getElementById("tr-price-fieldset");
  var priceMinEl = document.getElementById("tr-price-min");
  var priceMaxEl = document.getElementById("tr-price-max");
  var inStockEl = document.getElementById("tr-in-stock");
  var rebateOnlyEl = document.getElementById("tr-rebate-only");
  var onSaleOnlyEl = document.getElementById("tr-on-sale-only");
  var runFlatOnlyEl = document.getElementById("tr-run-flat-only");
  var studdableOnlyEl = document.getElementById("tr-studdable-only");
  var evOnlyEl = document.getElementById("tr-ev-only");
  var oemOnlyEl = document.getElementById("tr-oem-only");
  var rebateWrap = document.getElementById("tr-rebate-wrap");
  var onSaleWrap = document.getElementById("tr-on-sale-wrap");
  var runFlatWrap = document.getElementById("tr-run-flat-wrap");
  var studdableWrap = document.getElementById("tr-studdable-wrap");
  var evWrap = document.getElementById("tr-ev-wrap");
  var oemWrap = document.getElementById("tr-oem-wrap");
  var clearFiltersBtn = document.getElementById("tr-clear-filters");
  var filtersPanel = document.getElementById("tr-filters");
  var filtersOpenBtn = document.getElementById("tr-filters-open");
  var filtersCloseBtn = document.getElementById("tr-filters-close");
  var overlayEl = document.getElementById("tr-overlay");
  var refineLink = document.getElementById("tr-refine-link");
  var compareBar = document.getElementById("tr-compare-bar");
  var compareCountEl = document.getElementById("tr-compare-count");
  var compareClearBtn = document.getElementById("tr-compare-clear");

  function updateCompareBar() {
    if (!window.SpecrTireCompare || !compareBar) return;
    var n = window.SpecrTireCompare.list().length;
    compareBar.hidden = n === 0;
    if (compareCountEl) compareCountEl.textContent = String(n);
  }

  if (compareClearBtn && window.SpecrTireCompare) {
    compareClearBtn.addEventListener("click", function () {
      window.SpecrTireCompare.clear();
      updateCompareBar();
    });
  }
  window.addEventListener("specr:tire-compare-changed", updateCompareBar);
  updateCompareBar();

  var allProducts = [];
  var apiData = null;
  var initialFacets = null;

  var selectedBrands = new Set();
  var selectedSeasons = new Set();
  var selectedProtectionPrograms = new Set();
  var selectedSpeedRatings = new Set();
  var selectedVehicleTypes = new Set();
  var selectedLoadIndices = new Set();
  var selectedTreadwearBuckets = new Set();
  var selectedUtqgTractions = new Set();
  var selectedUtqgTemps = new Set();

  var oemChooserEl = document.getElementById("tr-oem-chooser");
  var staggerSizeFilter = "all";
  var staggerFrontSize = "";
  var staggerRearSize = "";
  var priceDebounceTimer = null;
  var recDebounceTimer = null;
  var lastFocusBeforeDrawer = null;

  var SEARCH_PARAM_KEYS = ["size", "vendor", "vin", "year", "make", "model", "trim", "vehicleId"];
  var PROFILE_PARAM_KEYS = ["goal", "driving", "priority"];

  var recommendationRankByProductId = {};
  var recommendationsList = [];
  var recommendationsLlmStatus = "unknown";

  function escHtml(s) {
    var d = document.createElement("div");
    d.textContent = s || "";
    return d.innerHTML;
  }

  function show(el) {
    if (el) el.hidden = false;
  }

  function hide(el) {
    if (el) el.hidden = true;
  }

  function splitParamList(raw) {
    return (raw || "")
      .split(",")
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function addToSetFromParam(set, paramName) {
    set.clear();
    splitParamList(new URLSearchParams(window.location.search).get(paramName)).forEach(function (v) {
      set.add(v);
    });
  }

  function parseUtqg(utqg) {
    var raw = (utqg || "").trim();
    if (!raw) return {};
    var parts = raw.split(/\s+/).filter(Boolean);
    var treadMatch = parts[0] && parts[0].match(/^(\d+)/);
    var treadwear = treadMatch ? parseInt(treadMatch[1], 10) : undefined;
    var traction;
    var temperature;
    if (parts.length >= 2 && /^[A-F]$/i.test(parts[1])) traction = parts[1].toUpperCase();
    if (parts.length >= 3 && /^[A-F]$/i.test(parts[2])) temperature = parts[2].toUpperCase();
    if (!traction && parts.length >= 2) {
      var letters = parts.slice(1).filter(function (p) {
        return /^[A-F]$/i.test(p);
      });
      if (letters[0]) traction = letters[0].toUpperCase();
      if (letters[1]) temperature = letters[1].toUpperCase();
    }
    return { treadwear: treadwear, traction: traction, temperature: temperature };
  }

  function treadwearBucket(tw) {
    if (tw == null || isNaN(tw)) return null;
    if (tw < 40) return "under-40";
    if (tw < 60) return "40-60";
    if (tw < 80) return "60-80";
    return "80-plus";
  }

  function maxTreadwear(product) {
    var max = 0;
    (product.variants || []).forEach(function (v) {
      var tw = parseUtqg(v.utqg).treadwear;
      if (tw != null && tw > max) max = tw;
    });
    return max;
  }

  function variantOnSale(v) {
    var msrp = parseFloat(v.msrp || "");
    var price = parseFloat(v.price || "");
    return !isNaN(msrp) && !isNaN(price) && msrp > 0 && msrp > price;
  }

  function setError(msg) {
    if (!errorEl) return;
    if (msg) {
      errorEl.textContent = msg;
      show(errorEl);
    } else {
      errorEl.textContent = "";
      hide(errorEl);
    }
  }

  function buildSearchParams() {
    var params = new URLSearchParams(window.location.search);
    var out = new URLSearchParams();
    SEARCH_PARAM_KEYS.forEach(function (key) {
      var val = params.get(key);
      if (val) out.set(key, val);
    });
    PROFILE_PARAM_KEYS.forEach(function (key) {
      var val = params.get(key);
      if (val) out.set(key, val);
    });
    if (window.SpecrTireProfile) {
      window.SpecrTireProfile.appendProfileToSearchParams(out);
    }
    return out;
  }

  function buildApiUrl() {
    var out = buildSearchParams();
    var qs = out.toString();
    return qs ? PROXY + "?" + qs : null;
  }

  function buildRecommendationsUrl() {
    var out = buildSearchParams();
    var qs = out.toString();
    return qs ? REC_PROXY + "?" + qs : null;
  }

  function persistTireSearchContextForChat() {
    var out = buildSearchParams();
    var obj = {};
    out.forEach(function (val, key) {
      obj[key] = val;
    });
    try {
      sessionStorage.setItem(TIRE_SEARCH_CONTEXT_KEY, JSON.stringify(obj));
    } catch (e) {}
    root.setAttribute("data-tire-search", out.toString());
  }

  function readUiFiltersFromUrl() {
    addToSetFromParam(selectedBrands, "brand");
    addToSetFromParam(selectedSeasons, "season");
    addToSetFromParam(selectedProtectionPrograms, "protection");
    addToSetFromParam(selectedSpeedRatings, "speed");
    addToSetFromParam(selectedVehicleTypes, "vehicleType");
    addToSetFromParam(selectedLoadIndices, "loadIndex");
    addToSetFromParam(selectedTreadwearBuckets, "treadwear");
    addToSetFromParam(selectedUtqgTractions, "utqgTraction");
    addToSetFromParam(selectedUtqgTemps, "utqgTemp");
    var params = new URLSearchParams(window.location.search);
    if (priceMinEl) priceMinEl.value = params.get("priceMin") || "";
    if (priceMaxEl) priceMaxEl.value = params.get("priceMax") || "";
    if (inStockEl) inStockEl.checked = params.get("inStock") === "1";
    if (rebateOnlyEl) rebateOnlyEl.checked = params.get("rebate") === "1";
    if (onSaleOnlyEl) onSaleOnlyEl.checked = params.get("onSale") === "1";
    if (runFlatOnlyEl) runFlatOnlyEl.checked = params.get("runFlat") === "1";
    if (studdableOnlyEl) studdableOnlyEl.checked = params.get("studdable") === "1";
    if (evOnlyEl) evOnlyEl.checked = params.get("ev") === "1";
    if (oemOnlyEl) oemOnlyEl.checked = params.get("oem") === "1";
    if (sortEl && params.get("sort")) sortEl.value = params.get("sort");
  }

  function writeUiFiltersToUrl() {
    var next = new URLSearchParams();
    SEARCH_PARAM_KEYS.forEach(function (key) {
      var val = new URLSearchParams(window.location.search).get(key);
      if (val) next.set(key, val);
    });
    if (selectedBrands.size) next.set("brand", Array.from(selectedBrands).join(","));
    if (selectedSeasons.size) next.set("season", Array.from(selectedSeasons).join(","));
    if (selectedProtectionPrograms.size) {
      next.set("protection", Array.from(selectedProtectionPrograms).join(","));
    }
    if (selectedSpeedRatings.size) next.set("speed", Array.from(selectedSpeedRatings).join(","));
    if (selectedVehicleTypes.size) next.set("vehicleType", Array.from(selectedVehicleTypes).join(","));
    if (selectedLoadIndices.size) next.set("loadIndex", Array.from(selectedLoadIndices).join(","));
    if (selectedTreadwearBuckets.size) next.set("treadwear", Array.from(selectedTreadwearBuckets).join(","));
    if (selectedUtqgTractions.size) next.set("utqgTraction", Array.from(selectedUtqgTractions).join(","));
    if (selectedUtqgTemps.size) next.set("utqgTemp", Array.from(selectedUtqgTemps).join(","));
    if (priceMinEl && priceMinEl.value !== "") next.set("priceMin", priceMinEl.value);
    if (priceMaxEl && priceMaxEl.value !== "") next.set("priceMax", priceMaxEl.value);
    if (inStockEl && inStockEl.checked) next.set("inStock", "1");
    if (rebateOnlyEl && rebateOnlyEl.checked) next.set("rebate", "1");
    if (onSaleOnlyEl && onSaleOnlyEl.checked) next.set("onSale", "1");
    if (runFlatOnlyEl && runFlatOnlyEl.checked) next.set("runFlat", "1");
    if (studdableOnlyEl && studdableOnlyEl.checked) next.set("studdable", "1");
    if (evOnlyEl && evOnlyEl.checked) next.set("ev", "1");
    if (oemOnlyEl && oemOnlyEl.checked) next.set("oem", "1");
    if (sortEl && sortEl.value) next.set("sort", sortEl.value);
    PROFILE_PARAM_KEYS.forEach(function (key) {
      var val = new URLSearchParams(window.location.search).get(key);
      if (val) next.set(key, val);
    });
    var qs = next.toString();
    history.replaceState(null, "", qs ? window.location.pathname + "?" + qs : window.location.pathname);
  }

  function trackEvent(name, params) {
    if (typeof window.gtag === "function") {
      window.gtag("event", name, params || {});
    }
  }

  function debouncedRenderGrid() {
    if (priceDebounceTimer) clearTimeout(priceDebounceTimer);
    priceDebounceTimer = setTimeout(function () {
      renderGrid();
      writeUiFiltersToUrl();
    }, 300);
  }

  function productMinPrice(product) {
    var fromApi = product.minPrice != null ? parseFloat(product.minPrice) : NaN;
    if (!isNaN(fromApi)) return fromApi;
    var prices = (product.variants || [])
      .map(function (v) {
        return parseFloat(v.price);
      })
      .filter(function (n) {
        return !isNaN(n);
      });
    return prices.length ? Math.min.apply(null, prices) : 0;
  }

  function productMinInStockPrice(product) {
    var prices = (product.variants || [])
      .filter(function (v) {
        return v.available;
      })
      .map(function (v) {
        return parseFloat(v.price);
      })
      .filter(function (n) {
        return !isNaN(n) && n > 0;
      });
    return prices.length ? Math.min.apply(null, prices) : productMinPrice(product);
  }

  function productHasStock(product) {
    return (product.variants || []).some(function (v) {
      return v.available;
    });
  }

  function brandBrowseHasStock(product) {
    if (product.hasStock != null) return !!product.hasStock;
    var sizeCount =
      product.sizeCount != null && product.sizeCount > 0
        ? product.sizeCount
        : (product.variants || []).length;
    if (sizeCount > 1) return true;
    return productHasStock(product);
  }

  function isBrandBrowseContext() {
    var ctx = apiData && apiData.context;
    return !!(ctx && ctx.type === "brand" && !ctx.size);
  }

  function appendBrandBrowseToPdpHref(href) {
    if (!isBrandBrowseContext()) return href;
    return href + (href.indexOf("?") >= 0 ? "&" : "?") + "browse=brand";
  }

  function productSeasons(product) {
    var set = new Set();
    (product.variants || []).forEach(function (v) {
      var s = (v.season || product.season || "").trim();
      if (s) set.add(s);
    });
    return set;
  }

  function variantMatchesVariantFilters(product) {
    if (
      selectedSpeedRatings.size === 0 &&
      selectedLoadIndices.size === 0 &&
      selectedTreadwearBuckets.size === 0 &&
      selectedUtqgTractions.size === 0 &&
      selectedUtqgTemps.size === 0
    ) {
      return true;
    }
    return (product.variants || []).some(function (v) {
      var speed = (v.speedRating || "").trim().toUpperCase();
      if (selectedSpeedRatings.size > 0 && (!speed || !selectedSpeedRatings.has(speed))) return false;

      var load = (v.loadIndex || "").trim();
      if (selectedLoadIndices.size > 0 && (!load || !selectedLoadIndices.has(load))) return false;

      var parsed = parseUtqg(v.utqg);
      var bucket = treadwearBucket(parsed.treadwear);
      if (selectedTreadwearBuckets.size > 0 && (!bucket || !selectedTreadwearBuckets.has(bucket))) return false;

      if (selectedUtqgTractions.size > 0) {
        if (!parsed.traction || !selectedUtqgTractions.has(parsed.traction)) return false;
      }
      if (selectedUtqgTemps.size > 0) {
        if (!parsed.temperature || !selectedUtqgTemps.has(parsed.temperature)) return false;
      }
      return true;
    });
  }

  function productHazardProtections(product) {
    if (product.hazardProtections && product.hazardProtections.length > 0) {
      return product.hazardProtections;
    }
    if (product.hazardProtection && product.hazardProtection.programId) {
      return [product.hazardProtection];
    }
    return [];
  }

  function buildProtectionHtml(product) {
    var protections = productHazardProtections(product);
    if (!protections.length) return "";
    var badges = protections
      .map(function (hp) {
        if (!hp || !hp.label) return "";
        return (
          '<span class="tr-card__badge tr-card__badge--protection">' +
          escHtml(hp.label) +
          "</span>"
        );
      })
      .filter(Boolean)
      .join("");
    if (!badges) return "";
    return '<div class="tr-card__protection">' + badges + "</div>";
  }

  function passesFilters(product) {
    var vendor = (product.vendor || "").trim() || "(Unknown)";
    if (selectedBrands.size > 0 && !selectedBrands.has(vendor)) return false;

    if (selectedSeasons.size > 0) {
      var seasons = productSeasons(product);
      var seasonMatch = false;
      selectedSeasons.forEach(function (s) {
        if (seasons.has(s)) seasonMatch = true;
      });
      if (!seasonMatch) return false;
    }

    if (selectedProtectionPrograms.size > 0) {
      var protections = productHazardProtections(product);
      var programMatch = protections.some(function (hp) {
        return hp && hp.programId && selectedProtectionPrograms.has(hp.programId);
      });
      if (!programMatch) return false;
    }

    if (selectedVehicleTypes.size > 0) {
      var vt = product.vehicleType || "";
      if (!vt || !selectedVehicleTypes.has(vt)) return false;
    }

    if (!variantMatchesVariantFilters(product)) return false;

    var minP = productMinPrice(product);
    var priceMin = priceMinEl && priceMinEl.value !== "" ? parseFloat(priceMinEl.value) : null;
    var priceMax = priceMaxEl && priceMaxEl.value !== "" ? parseFloat(priceMaxEl.value) : null;
    if (priceMin != null && !isNaN(priceMin) && minP < priceMin) return false;
    if (priceMax != null && !isNaN(priceMax) && minP > priceMax) return false;

    if (inStockEl && inStockEl.checked) {
      var inStock = isBrandBrowseContext() ? brandBrowseHasStock(product) : productHasStock(product);
      if (!inStock) return false;
    }
    if (rebateOnlyEl && rebateOnlyEl.checked && !(product.rebate && product.rebate.badgeText)) return false;
    if (onSaleOnlyEl && onSaleOnlyEl.checked && !product.onSale) return false;
    if (runFlatOnlyEl && runFlatOnlyEl.checked && !product.runFlat) return false;
    if (studdableOnlyEl && studdableOnlyEl.checked && !product.studdable) return false;
    if (evOnlyEl && evOnlyEl.checked && !product.evOptimized) return false;
    if (oemOnlyEl && oemOnlyEl.checked && !product.oem) return false;

    if (staggerSizeFilter === "front" && staggerFrontSize) {
      if (!productMatchesStaggerSize(product, staggerFrontSize)) return false;
    } else if (staggerSizeFilter === "rear" && staggerRearSize) {
      if (!productMatchesStaggerSize(product, staggerRearSize)) return false;
    }

    return true;
  }

  function sortProducts(products) {
    var mode = (sortEl && sortEl.value) || "price_asc";
    var list = products.slice();
    list.sort(function (a, b) {
      var stockFn = isBrandBrowseContext() ? brandBrowseHasStock : productHasStock;
      var aStock = stockFn(a) ? 1 : 0;
      var bStock = stockFn(b) ? 1 : 0;
      if (aStock !== bStock) return bStock - aStock;

      if (mode === "recommended" && recommendationsList.length) {
        var ar = recommendationRankByProductId[a.productId];
        var br = recommendationRankByProductId[b.productId];
        if (ar != null || br != null) {
          if (ar == null) return 1;
          if (br == null) return -1;
          return ar - br;
        }
      }
      if (mode === "rebate_first") {
        var ar = a.rebate && a.rebate.badgeText ? 1 : 0;
        var br = b.rebate && b.rebate.badgeText ? 1 : 0;
        if (ar !== br) return br - ar;
        return productMinPrice(a) - productMinPrice(b);
      }
      if (mode === "featured") {
        var af = a.featured ? 1 : 0;
        var bf = b.featured ? 1 : 0;
        if (af !== bf) return bf - af;
        return productMinPrice(a) - productMinPrice(b);
      }
      if (mode === "treadwear_desc") {
        return maxTreadwear(b) - maxTreadwear(a);
      }
      if (mode === "price_asc") return productMinPrice(a) - productMinPrice(b);
      if (mode === "price_desc") return productMinPrice(b) - productMinPrice(a);
      if (mode === "brand_asc") {
        var va = (a.vendor || "").toLowerCase();
        var vb = (b.vendor || "").toLowerCase();
        if (va !== vb) return va < vb ? -1 : 1;
        return (a.title || "").localeCompare(b.title || "");
      }
      return (a.title || "").localeCompare(b.title || "");
    });
    return list;
  }

  function normalizeTireSizeLabel(size) {
    return String(size || "")
      .toUpperCase()
      .replace(/\s+/g, "")
      .replace(/ZR/g, "R");
  }

  function tireRimDiameter(size) {
    var m = String(size || "").match(/R(\d{2})/i);
    return m ? m[1] : "";
  }

  function isStaggeredOemFitment(sizes) {
    if (!sizes || sizes.length < 2) return false;
    var a = normalizeTireSizeLabel(sizes[0]);
    var b = normalizeTireSizeLabel(sizes[1]);
    return !!(a && b && a !== b);
  }

  function staggerPairFromContext(context) {
    if (!context) return null;
    var front = context.oemFrontSize || "";
    var rear = context.oemRearSize || "";
    if (
      front &&
      rear &&
      normalizeTireSizeLabel(front) !== normalizeTireSizeLabel(rear)
    ) {
      return [front, rear];
    }
    if (context.oemSizes && isStaggeredOemFitment(context.oemSizes)) {
      return [context.oemSizes[0], context.oemSizes[1]];
    }
    return null;
  }

  function syncStaggerSizeContext(context) {
    staggerSizeFilter = "all";
    staggerFrontSize = "";
    staggerRearSize = "";
    var pair = staggerPairFromContext(context);
    if (!pair) return;
    staggerFrontSize = pair[0] || "";
    staggerRearSize = pair[1] || "";
  }

  function productMatchesStaggerSize(product, targetSize) {
    if (!targetSize) return true;
    var target = normalizeTireSizeLabel(targetSize);
    return (product.variants || []).some(function (v) {
      return normalizeTireSizeLabel(v.tireSize) === target;
    });
  }

  function formatStaggeredOemBanner(sizes) {
    return (
      "OEM staggered fitment: " +
      escHtml(sizes[0]) +
      " (front), " +
      escHtml(sizes[1]) +
      " (rear)"
    );
  }

  function applySizeSeoMeta(context) {
    if (!context || context.type !== "size") return;
    var label = context.label || "";
    var collectionUrl = context.collectionUrl || "";
    if (label) {
      document.title = label + " tires in Calgary — " + (window.shopName || "Spec R");
      var titleEl = document.querySelector(".tr-title");
      if (titleEl) titleEl.textContent = label + " tires";
    }
    if (collectionUrl) {
      var existing = document.querySelector('link[rel="canonical"][data-specr-size-canonical]');
      if (existing) existing.remove();
      var link = document.createElement("link");
      link.rel = "canonical";
      link.href = collectionUrl.indexOf("http") === 0 ? collectionUrl : window.location.origin + collectionUrl;
      link.setAttribute("data-specr-size-canonical", "1");
      document.head.appendChild(link);
    }
  }

  function renderContextBanner(context) {
    if (!contextBanner || !context) {
      if (contextBanner) contextBanner.innerHTML = "";
      return;
    }

    var html = "";
    if (context.type === "size") {
      html =
        '<p class="tr-context-banner__text">Tires for <strong>' +
        escHtml(context.label) +
        "</strong></p>";
      if (context.collectionUrl) {
        html +=
          '<p class="tr-context-banner__meta"><a href="' +
          escHtml(context.collectionUrl) +
          '">View as collection</a></p>';
      }
    } else if (context.type === "vehicle") {
      html =
        '<p class="tr-context-banner__text">Tires for <strong>' +
        escHtml(context.label) +
        "</strong></p>";
      var staggerPair = staggerPairFromContext(context);
      if (staggerPair) {
        html += '<p class="tr-context-banner__meta">' + formatStaggeredOemBanner(staggerPair) + "</p>";
      } else if (context.oemSizes && context.oemSizes.length) {
        html +=
          '<p class="tr-context-banner__meta">OEM size: ' +
          context.oemSizes.map(escHtml).join(", ") +
          "</p>";
      } else if (context.wheelDiameter) {
        html +=
          '<p class="tr-context-banner__meta">Wheel diameter: ' +
          escHtml(context.wheelDiameter) +
          '"</p>';
      }
      if (context.fallbackToWheelDiameter) {
        html +=
          '<p class="tr-context-banner__note">Exact tire size not available — showing tires for this wheel diameter</p>';
      }
      if (context.message) {
        html += '<p class="tr-context-banner__note">' + escHtml(context.message) + "</p>";
      }
    } else if (context.type === "brand") {
      html =
        '<p class="tr-context-banner__text">Showing <strong>' +
        escHtml(context.label) +
        "</strong> tires</p>";
      html +=
        '<p class="tr-context-banner__meta">Refine by size or vehicle using filters, or change your search.</p>';
    }
    contextBanner.innerHTML = html;
    renderOemChooser(context);
  }

  function renderCurationNotice(count) {
    if (!curationNoticeEl) return;
    if (count > 0 && count < 5) {
      curationNoticeEl.hidden = false;
      curationNoticeEl.innerHTML =
        '<p class="tr-curation-notice__text">We publish curated Alberta inventory for performance and luxury vehicles — more sizes are added weekly. ' +
        '<a href="/pages/why-specr#curated-catalog">Why our catalog is curated</a> · ' +
        '<a href="/pages/tires">Try another search</a></p>';
    } else {
      curationNoticeEl.hidden = true;
      curationNoticeEl.innerHTML = "";
    }
  }

  function renderOemChooser(context) {
    if (!oemChooserEl) return;
    oemChooserEl.innerHTML = "";
    var staggerPair = staggerPairFromContext(context);
    if (staggerPair) {
      show(oemChooserEl);
      var staggerLead = document.createElement("p");
      staggerLead.className = "tr-oem-chooser__lead";
      staggerLead.textContent = "Your vehicle uses two sizes. Both are selected:";
      var staggerRow = document.createElement("div");
      staggerRow.className = "tr-oem-chooser__chips";
      [
        { axle: "front", label: "Front", size: staggerPair[0] },
        { axle: "rear", label: "Rear", size: staggerPair[1] },
      ].forEach(function (item) {
        var axleBtn = document.createElement("button");
        axleBtn.type = "button";
        axleBtn.className = "tr-oem-chip";
        var axleSelected = staggerSizeFilter === "all" || staggerSizeFilter === item.axle;
        if (axleSelected) axleBtn.classList.add("tr-oem-chip--active");
        axleBtn.setAttribute("aria-pressed", axleSelected ? "true" : "false");
        axleBtn.textContent = item.label + " " + item.size;
        axleBtn.addEventListener("click", function () {
          staggerSizeFilter = staggerSizeFilter === item.axle ? "all" : item.axle;
          renderOemChooser(context);
          renderGrid();
          writeUiFiltersToUrl();
        });
        staggerRow.appendChild(axleBtn);
      });
      oemChooserEl.appendChild(staggerLead);
      oemChooserEl.appendChild(staggerRow);
      return;
    }
    if (!context || !context.oemSizes || context.oemSizes.length < 2) {
      hide(oemChooserEl);
      return;
    }
    show(oemChooserEl);

    var lead = document.createElement("p");
    lead.className = "tr-oem-chooser__lead";
    lead.textContent = "Your vehicle may use one of these OEM sizes:";
    var row = document.createElement("div");
    row.className = "tr-oem-chooser__chips";
    context.oemSizes.forEach(function (size) {
      var btn = document.createElement("button");
      btn.type = "button";
      btn.className = "tr-oem-chip";
      btn.textContent = size;
      btn.addEventListener("click", function () {
        var m = String(size).match(/(\d{2,3})\s*\/\s*(\d{2})\s*R?\s*(\d{2})/i);
        if (m) {
          window.location.href =
            "/pages/tire-results?size=" + encodeURIComponent(m[1] + "-" + m[2] + "-" + m[3]);
        }
      });
      row.appendChild(btn);
    });

    oemChooserEl.appendChild(lead);
    oemChooserEl.appendChild(row);
  }

  function renderFacetCheckboxes(container, fieldset, items, valueKey, labelKey, selectedSet, inputClass) {
    if (!container || !fieldset) return;
    container.innerHTML = "";
    if (!items || !items.length) {
      hide(fieldset);
      return;
    }
    show(fieldset);
    items.forEach(function (item) {
      var value = item[valueKey];
      var labelText = item[labelKey] != null ? item[labelKey] : value;
      var count = item.count;
      var id = inputClass + "-" + String(value).replace(/[^a-z0-9]+/gi, "-").toLowerCase();
      var label = document.createElement("label");
      label.className = "tr-filter-check";
      label.htmlFor = id;
      var input = document.createElement("input");
      input.type = "checkbox";
      input.id = id;
      input.className = inputClass;
      input.value = value;
      input.checked = selectedSet.has(value);
      input.addEventListener("change", function () {
        if (input.checked) selectedSet.add(value);
        else selectedSet.delete(value);
        renderGrid();
        writeUiFiltersToUrl();
      });
      var span = document.createElement("span");
      span.textContent = labelText + " (" + count + ")";
      label.appendChild(input);
      label.appendChild(span);
      container.appendChild(label);
    });
  }

  function setupBooleanToggle(wrap, input, count) {
    if (!wrap || !input) return;
    if (count > 0) {
      show(wrap);
    } else {
      hide(wrap);
      input.checked = false;
    }
  }

  function setupBooleanToggles(facets) {
    var bc = (facets && facets.booleanCounts) || {};
    setupBooleanToggle(rebateWrap, rebateOnlyEl, bc.rebate || 0);
    setupBooleanToggle(onSaleWrap, onSaleOnlyEl, bc.onSale || 0);
    setupBooleanToggle(runFlatWrap, runFlatOnlyEl, bc.runFlat || 0);
    setupBooleanToggle(studdableWrap, studdableOnlyEl, bc.studdable || 0);
    setupBooleanToggle(evWrap, evOnlyEl, bc.evOptimized || 0);
    setupBooleanToggle(oemWrap, oemOnlyEl, bc.oem || 0);
  }

  function countMapFromProducts(products, keyFn) {
    var map = {};
    products.forEach(function (p) {
      var key = keyFn(p);
      if (!key) return;
      map[key] = (map[key] || 0) + 1;
    });
    return Object.keys(map)
      .sort()
      .map(function (k) {
        return { value: k, count: map[k] };
      });
  }

  function variantFacetFromProducts(products, extractor) {
    var map = {};
    products.forEach(function (p) {
      var seen = new Set();
      (p.variants || []).forEach(function (v) {
        var val = extractor(v, p);
        if (!val || seen.has(val)) return;
        seen.add(val);
        map[val] = (map[val] || 0) + 1;
      });
    });
    return Object.keys(map)
      .sort(function (a, b) {
        var na = parseInt(a, 10);
        var nb = parseInt(b, 10);
        if (!isNaN(na) && !isNaN(nb)) return na - nb;
        return a.localeCompare(b);
      })
      .map(function (value) {
        return { value: value, count: map[value] };
      });
  }

  function treadwearFacetsFromProducts(products) {
    var map = {};
    products.forEach(function (p) {
      var seen = new Set();
      (p.variants || []).forEach(function (v) {
        var bucket = treadwearBucket(parseUtqg(v.utqg).treadwear);
        if (!bucket || seen.has(bucket)) return;
        seen.add(bucket);
        map[bucket] = (map[bucket] || 0) + 1;
      });
    });
    return Object.keys(map)
      .sort()
      .map(function (id) {
        return { value: id, label: TREADWEAR_LABELS[id] || id, count: map[id] };
      });
  }

  function protectionFacetsFromProducts(products) {
    var map = {};
    products.forEach(function (p) {
      var seen = {};
      productHazardProtections(p).forEach(function (hp) {
        if (!hp || !hp.programId || seen[hp.programId]) return;
        seen[hp.programId] = true;
        var id = hp.programId;
        if (!map[id]) {
          map[id] = {
            id: id,
            label: hp.label || id,
            count: 0,
          };
        }
        map[id].count++;
      });
    });
    return Object.keys(map)
      .sort(function (a, b) {
        return map[a].label.localeCompare(map[b].label);
      })
      .map(function (id) {
        return map[id];
      });
  }

  function booleanCountsFromProducts(products) {
    var counts = { rebate: 0, runFlat: 0, studdable: 0, evOptimized: 0, oem: 0, onSale: 0 };
    products.forEach(function (p) {
      if (p.rebate && p.rebate.badgeText) counts.rebate++;
      if (p.runFlat) counts.runFlat++;
      if (p.studdable) counts.studdable++;
      if (p.evOptimized) counts.evOptimized++;
      if (p.oem) counts.oem++;
      if (p.onSale) counts.onSale++;
    });
    return counts;
  }

  function updateFacetCounts(filteredProducts) {
    renderFacetCheckboxes(
      brandFiltersEl,
      brandFieldset,
      countMapFromProducts(filteredProducts, function (p) {
        return (p.vendor || "").trim() || "(Unknown)";
      }).map(function (x) {
        return { name: x.value, count: x.count };
      }),
      "name",
      "name",
      selectedBrands,
      "tr-brand-check"
    );
    renderFacetCheckboxes(
      seasonFiltersEl,
      seasonFieldset,
      variantFacetFromProducts(filteredProducts, function (v, p) {
        return (v.season || p.season || "").trim();
      }),
      "value",
      "value",
      selectedSeasons,
      "tr-season-check"
    );
    renderFacetCheckboxes(
      protectionFiltersEl,
      protectionFieldset,
      protectionFacetsFromProducts(filteredProducts),
      "id",
      "label",
      selectedProtectionPrograms,
      "tr-protection-check"
    );
    renderFacetCheckboxes(
      speedFiltersEl,
      speedFieldset,
      variantFacetFromProducts(filteredProducts, function (v) {
        return (v.speedRating || "").trim().toUpperCase();
      }),
      "value",
      "value",
      selectedSpeedRatings,
      "tr-speed-check"
    );
    renderFacetCheckboxes(
      vehicleTypeFiltersEl,
      vehicleTypeFieldset,
      countMapFromProducts(filteredProducts, function (p) {
        return p.vehicleType || "";
      }),
      "value",
      "value",
      selectedVehicleTypes,
      "tr-vehicle-type-check"
    );
    renderFacetCheckboxes(
      loadIndexFiltersEl,
      loadIndexFieldset,
      variantFacetFromProducts(filteredProducts, function (v) {
        return (v.loadIndex || "").trim();
      }).slice(0, 24),
      "value",
      "value",
      selectedLoadIndices,
      "tr-load-index-check"
    );
    renderFacetCheckboxes(
      treadwearFiltersEl,
      treadwearFieldset,
      treadwearFacetsFromProducts(filteredProducts),
      "value",
      "label",
      selectedTreadwearBuckets,
      "tr-treadwear-check"
    );
    renderFacetCheckboxes(
      utqgTractionFiltersEl,
      utqgTractionFieldset,
      variantFacetFromProducts(filteredProducts, function (v) {
        return parseUtqg(v.utqg).traction;
      }),
      "value",
      "value",
      selectedUtqgTractions,
      "tr-utqg-traction-check"
    );
    renderFacetCheckboxes(
      utqgTempFiltersEl,
      utqgTempFieldset,
      variantFacetFromProducts(filteredProducts, function (v) {
        return parseUtqg(v.utqg).temperature;
      }),
      "value",
      "value",
      selectedUtqgTemps,
      "tr-utqg-temp-check"
    );
    setupBooleanToggles({ booleanCounts: booleanCountsFromProducts(filteredProducts) });
  }

  function setupPriceInputs(facets) {
    if (!priceFieldset || !priceMinEl || !priceMaxEl) return;
    if (!facets || facets.priceMax <= 0) {
      hide(priceFieldset);
      return;
    }
    show(priceFieldset);
    priceMinEl.placeholder = String(Math.floor(facets.priceMin));
    priceMaxEl.placeholder = String(Math.ceil(facets.priceMax));
    priceMinEl.min = "0";
    priceMaxEl.min = "0";
  }

  function numericVariantId(gid) {
    if (!gid) return "";
    var s = String(gid);
    var slash = s.lastIndexOf("/");
    return slash >= 0 ? s.slice(slash + 1) : s;
  }

  function buildCompareVariants(product) {
    var studdable = product.studdable ? "Yes" : "";
    var runFlat = product.runFlat ? "Yes" : "";
    var productSeason = (product.season || "").trim();
    return (product.variants || [])
      .map(function (v) {
        var vid = numericVariantId(v.variantId);
        var priceNum = parseFloat(v.price);
        return {
          variantId: vid || v.variantId,
          tireSize: v.tireSize || "",
          price: isNaN(priceNum) ? null : priceNum,
          season: (v.season || productSeason).trim(),
          speedLoad: [v.speedRating, v.loadIndex].filter(Boolean).join(""),
          utqg: v.utqg || "",
          studdable: studdable,
          runFlat: runFlat,
          available: !!v.available,
        };
      })
      .filter(function (v) {
        return v.tireSize;
      })
      .sort(function (a, b) {
        return a.tireSize.localeCompare(b.tireSize, undefined, { numeric: true });
      });
  }

  function pickMatchedVariant(product) {
    var variants = product.variants || [];
    if (!variants.length) return null;
    var preferredSize =
      staggerSizeFilter === "front"
        ? staggerFrontSize
        : staggerSizeFilter === "rear"
          ? staggerRearSize
          : "";
    if (preferredSize) {
      var target = normalizeTireSizeLabel(preferredSize);
      var preferred = variants.filter(function (v) {
        return normalizeTireSizeLabel(v.tireSize) === target;
      });
      if (preferred.length) {
        var availablePreferred = preferred.filter(function (v) {
          return v.available;
        });
        return availablePreferred[0] || preferred[0];
      }
    }
    var available = variants.filter(function (v) {
      return v.available;
    });
    return available[0] || variants[0];
  }

  function pickListingVariant(product) {
    var variants = product.variants || [];
    if (!variants.length) return null;
    var available = variants.filter(function (v) {
      return v.available;
    });
    return available[0] || variants[0];
  }

  function formatCardSizesHtml(uniqueSizes, product) {
    if (!uniqueSizes.length && !(product && product.sizeCount > 0)) return "";
    var ctx = apiData && apiData.context;
    var count =
      product && product.sizeCount != null && product.sizeCount > 0
        ? product.sizeCount
        : uniqueSizes.length;
    if (ctx && ctx.type === "brand") {
      if (count === 1) {
        return '<p class="tr-card__sizes">' + escHtml(uniqueSizes[0] || "1 size") + "</p>";
      }
      return (
        '<p class="tr-card__sizes tr-card__sizes--summary">' +
        count +
        " sizes available</p>"
      );
    }
    return (
      '<p class="tr-card__sizes">' + uniqueSizes.map(escHtml).join(", ") + "</p>"
    );
  }

  function formatRebateEnds(iso) {
    if (!iso) return "";
    try {
      var d = new Date(iso + "T12:00:00");
      return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
    } catch (e) {
      return iso;
    }
  }

  function buildRebateHtml(rebate) {
    if (!rebate || !rebate.badgeText) return "";
    var label = escHtml(rebate.badgeText);
    var poster =
      rebate.posterUrl ?
        '<a href="' +
        escHtml(rebate.posterUrl) +
        '" class="tr-card__rebate-poster-link" target="_blank" rel="noopener noreferrer">' +
        '<img class="tr-card__rebate-poster" src="' +
        escHtml(rebate.posterUrl) +
        '" alt="" loading="lazy" width="120" height="80" />' +
        "</a>"
      : "";
    var inner = rebate.url
      ? '<a href="' +
        escHtml(rebate.url) +
        '" class="tr-card__rebate-link" target="_blank" rel="noopener noreferrer">' +
        label +
        "</a>"
      : '<span class="tr-card__rebate-text">' + label + "</span>";
    var ends =
      rebate.endsAt ?
        '<span class="tr-card__rebate-ends">Offer ends ' + escHtml(formatRebateEnds(rebate.endsAt)) + "</span>"
      : "";
    return '<div class="tr-card__rebate">' + poster + '<p class="tr-card__rebate-text-wrap">' + inner + ends + "</p></div>";
  }

  function applyRecommendationRanks(data) {
    recommendationsList = (data && data.recommendations) || [];
    recommendationsLlmStatus = (data && data.llmStatus) || "unknown";
    recommendationRankByProductId = {};
    recommendationsList.forEach(function (rec) {
      recommendationRankByProductId[rec.productId] = rec.rank;
    });

    trackEvent("tire_recommendations_view", {
      goal: (data.profile && data.profile.goal) || "",
      pick_count: recommendationsList.length,
      llm_status: data.llmStatus || "unknown",
    });

    var recRow = document.getElementById("tr-recommended-row");
    if (recRow) recRow.hidden = true;

    renderGrid();
  }

  function buildRecommendationReasonHtml(productId) {
    if (!recommendationsList.length) return "";
    var rec = recommendationsList.find(function (r) {
      return r.productId === productId;
    });
    if (!rec) return "";
    var reasonText =
      recommendationsLlmStatus === "ok" && rec.reasonAi ? rec.reasonAi : rec.reasonShort;
    if (!reasonText) return "";
    var aiLabel =
      recommendationsLlmStatus === "ok" && rec.reasonAi
        ? '<span class="tr-rec-card__ai-label">AI pick</span>'
        : "";
    return (
      '<div class="tr-rec-card__reason-wrap">' +
      aiLabel +
      '<p class="tr-rec-card__reason">' +
      escHtml(reasonText) +
      "</p></div>"
    );
  }

  function loadRecommendations() {
    var url = buildRecommendationsUrl();
    if (!url) return;

    fetch(url, { method: "GET", headers: { Accept: "application/json" } })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (out) {
        var data = out.data || {};
        if (!out.ok || data.error) return;
        applyRecommendationRanks(data);
      })
      .catch(function () {});
  }

  function scheduleLoadRecommendations() {
    if (recDebounceTimer) clearTimeout(recDebounceTimer);
    recDebounceTimer = setTimeout(function () {
      function run() {
        if (window.SpecrTireProfile && !window.SpecrTireProfile.isRecommendationsEnabled()) {
          var recRow = document.getElementById("tr-recommended-row");
          if (recRow) recRow.hidden = true;
          return;
        }
        loadRecommendations();
      }
      if (window.SpecrTireProfile && window.SpecrTireProfile.whenConfigReady) {
        window.SpecrTireProfile.whenConfigReady(run);
      } else {
        run();
      }
    }, 300);
  }

  function syncProfileFromUrl() {
    if (!window.SpecrTireProfile) return;
    var profile = window.SpecrTireProfile.readProfile();
    if (profile && profile.goal) window.SpecrTireProfile.writeProfile(profile);
  }

  function getStaggeredVariants(product, frontSize, rearSize) {
    var front = null;
    var rear = null;
    var frontTarget = normalizeTireSizeLabel(frontSize);
    var rearTarget = normalizeTireSizeLabel(rearSize);
    (product.variants || []).forEach(function (v) {
      var norm = normalizeTireSizeLabel(v.tireSize);
      if (norm === frontTarget) front = v;
      if (norm === rearTarget) rear = v;
    });
    return { front: front, rear: rear };
  }

  function variantPriceNum(variant) {
    return variant && variant.price ? parseFloat(variant.price) : 0;
  }

  function buildTrCardMediaHtml(product, soldOut, badgeWrapHtml) {
    var mediaInner = TIRE_ICON;
    if (product.imageUrl) {
      mediaInner =
        '<img src="' +
        escHtml(product.imageUrl) +
        '" alt="' +
        escHtml(product.imageAlt || product.title || "Tire") +
        '" loading="lazy" decoding="async" />';
    } else {
      mediaInner =
        '<div class="tr-card__media-fallback" data-tire-brand-fallback data-vendor="' +
        escHtml(product.vendor || "") +
        '">' +
        TIRE_ICON +
        "</div>";
    }
    return (
      '<div class="tr-card__media' +
      (soldOut ? " tr-card__media--sold-out" : "") +
      '">' +
      mediaInner +
      (badgeWrapHtml || "") +
      "</div>"
    );
  }

  function attachTrCardNavigation(card, href) {
    card.setAttribute("data-href", href);
    card.style.cursor = "pointer";
    card.addEventListener("click", function (e) {
      if (
        e.target.closest(".tr-card__compare") ||
        e.target.closest(".tr-card__rebate-link") ||
        e.target.closest(".tr-card__stagger-link") ||
        e.target.closest(".tr-card__stagger-add")
      ) {
        return;
      }
      window.location.href = href;
    });
  }

  function attachTrCardCompare(card, product, options) {
    if (!window.SpecrTireCompare) return;
    var compareBtn = card.querySelector(".tr-card__compare");
    if (!compareBtn) return;

    var variant = options.variant;
    var href = options.href;
    var matchedSize = options.matchedSize || "";
    var uniqueSizes = options.uniqueSizes || [];
    var priceLabel = options.priceLabel || "";
    var minPrice = options.minPrice || 0;

    compareBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var vid = numericVariantId(variant.variantId);
      var compareVariants = buildCompareVariants(product);
      var picked =
        compareVariants.find(function (v) {
          return String(v.variantId) === String(vid);
        }) || compareVariants[0];
      window.SpecrTireCompare.add({
        variantId: vid || variant.variantId,
        title: (product.vendor ? product.vendor + " " : "") + (product.title || ""),
        size: picked ? picked.tireSize : matchedSize || uniqueSizes[0] || "",
        price: priceLabel,
        priceNum: minPrice,
        url: href,
        season: picked ? picked.season : (variant.season || product.season || "").trim(),
        speedLoad: picked
          ? picked.speedLoad
          : [variant.speedRating, variant.loadIndex].filter(Boolean).join("") ||
            (variant.speedLoad || ""),
        utqg: picked ? picked.utqg : variant.utqg || "",
        studdable: picked ? picked.studdable : product.studdable ? "Yes" : "",
        runFlat: picked ? picked.runFlat : product.runFlat ? "Yes" : "",
        handle: product.handle,
        variants: compareVariants,
      });
      updateCompareBar();
    });
  }

  function wrapTrGridCard(card) {
    var li = document.createElement("li");
    li.className = "tr-grid__item";
    li.appendChild(card);
    return li;
  }

  function renderStaggeredRow(label, variant, productHandle) {
    if (!variant) return "";
    var price = variantPriceNum(variant);
    var href = "/products/" + productHandle;
    var vid = numericVariantId(variant.variantId);
    if (vid) href += "?variant=" + encodeURIComponent(vid);
    href = appendBrandBrowseToPdpHref(href);
    var staggerTier = variant.stockTier;
    var staggerLabel =
      staggerTier === "in"
        ? "In stock"
        : staggerTier === "limited"
          ? "Limited — book soon"
          : staggerTier === "contact"
            ? "Contact us"
            : variant.available
              ? "In stock"
              : "Contact us";
    var staggerClass =
      staggerTier === "in" || (!staggerTier && variant.available)
        ? "tr-card__stagger-stock--in"
        : staggerTier === "limited"
          ? "tr-card__stagger-stock--low"
          : "tr-card__stagger-stock--out";
    var stock =
      '<span class="tr-card__stagger-stock ' + staggerClass + '">' + escHtml(staggerLabel) + "</span>";
    return (
      '<div class="tr-card__stagger-row">' +
      '<span class="tr-card__stagger-label">' +
      escHtml(label) +
      "</span>" +
      '<div class="tr-card__stagger-detail">' +
      '<span class="tr-card__stagger-size">' +
      escHtml(variant.tireSize || "") +
      "</span>" +
      '<span class="tr-card__stagger-price">$' +
      price.toFixed(2) +
      " each</span>" +
      stock +
      '<a class="tr-card__stagger-link" href="' +
      escHtml(href) +
      '">View</a>' +
      "</div></div>"
    );
  }

  function addStaggeredToCart(frontV, rearV, button) {
    var items = [];
    if (frontV) {
      var frontId = Number(numericVariantId(frontV.variantId));
      if (frontId) items.push({ id: frontId, quantity: 2 });
    }
    if (rearV) {
      var rearId = Number(numericVariantId(rearV.variantId));
      if (rearId) items.push({ id: rearId, quantity: 2 });
    }
    if (!items.length) return;
    var original = button.textContent;
    button.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart");
        window.location.href = "/cart";
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = "Could not add — try again";
        setTimeout(function () {
          if (button.textContent.indexOf("Could not add") === 0) button.textContent = original;
        }, 2500);
      });
  }

  function renderStaggeredProductCard(product, staggered) {
    var frontV = staggered.front;
    var rearV = staggered.rear;
    var frontPrice = variantPriceNum(frontV);
    var rearPrice = variantPriceNum(rearV);
    var setOf4 = frontV && rearV ? (frontPrice + rearPrice) * 2 : 0;
    var addLabel = frontV && rearV ? "Add 2 front + 2 rear" : frontV ? "Add 2 front" : "Add 2 rear";

    var rebateHtml = buildRebateHtml(product.rebate);
    var installCaption = installCaptionForStaggered(frontV, rearV);
    var protectionHtml = buildProtectionHtml(product);
    var mainHref = appendBrandBrowseToPdpHref("/products/" + product.handle);
    var compareVariant = frontV || rearV || (product.variants && product.variants[0]);
    var showCompare = window.SpecrTireCompare && compareVariant;

    var card = document.createElement("article");
    card.className = "tr-card tr-card--staggered";
    card.setAttribute("role", "listitem");

    card.innerHTML =
      buildTrCardMediaHtml(product, false, "") +
      '<div class="tr-card__body">' +
      (product.vendor ? '<p class="tr-card__vendor">' + escHtml(product.vendor) + "</p>" : "") +
      '<p class="tr-card__title">' +
      escHtml(product.title) +
      "</p>" +
      '<div class="tr-card__stagger">' +
      renderStaggeredRow("Front", frontV, product.handle) +
      renderStaggeredRow("Rear", rearV, product.handle) +
      "</div>" +
      '<div class="tr-card__extras">' +
      installCaption +
      protectionHtml +
      rebateHtml +
      "</div>" +
      '<div class="tr-card__actions">' +
      '<div class="tr-card__pricing">' +
      (setOf4 > 0
        ? '<p class="tr-card__set-price">Set of 4: $' + setOf4.toFixed(2) + "</p>"
        : '<p class="tr-card__price">View sizes</p>') +
      '<button type="button" class="tr-card__stagger-add">' +
      escHtml(addLabel) +
      "</button>" +
      "</div>" +
      (showCompare ? '<button type="button" class="tr-card__compare">Compare</button>' : "") +
      "</div></div>";

    attachTrCardNavigation(card, mainHref);

    var addBtn = card.querySelector(".tr-card__stagger-add");
    if (addBtn) {
      addBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        addStaggeredToCart(frontV, rearV, addBtn);
      });
    }

    if (showCompare) {
      attachTrCardCompare(card, product, {
        variant: compareVariant,
        href: mainHref,
        matchedSize: frontV ? frontV.tireSize : "",
        uniqueSizes: [],
        priceLabel: setOf4 > 0 ? "$" + setOf4.toFixed(2) : "",
        minPrice: setOf4 / 4,
      });
    }

    var rebateLink = card.querySelector(".tr-card__rebate-link");
    if (rebateLink) {
      rebateLink.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    }

    return wrapTrGridCard(card);
  }

  function renderProductCard(product) {
    var sizes = (product.variants || [])
      .map(function (vr) {
        return vr.tireSize;
      })
      .filter(Boolean);
    var uniqueSizes = [];
    sizes.forEach(function (s) {
      if (uniqueSizes.indexOf(s) === -1) uniqueSizes.push(s);
    });
    var brandBrowse = isBrandBrowseContext();
    var sizeCount =
      product.sizeCount != null && product.sizeCount > 0 ? product.sizeCount : uniqueSizes.length;
    var bestVariant = brandBrowse ? pickListingVariant(product) : pickMatchedVariant(product);
    var matchedSize = brandBrowse ? "" : bestVariant ? bestVariant.tireSize : "";
    var brandInStock = brandBrowse ? brandBrowseHasStock(product) : productHasStock(product);
    var soldOut = brandBrowse ? !brandInStock : !bestVariant || !bestVariant.available;
    var minPrice =
      brandBrowse && brandInStock
        ? productMinInStockPrice(product)
        : productMinPrice(product);

    var href = "/products/" + product.handle;
    if (!brandBrowse && bestVariant) {
      var vid = numericVariantId(bestVariant.variantId);
      if (vid) href += "?variant=" + encodeURIComponent(vid);
    }
    href = appendBrandBrowseToPdpHref(href);

    var pickRank = recommendationRankByProductId[product.productId];
    if (pickRank != null) {
      href += (href.indexOf("?") >= 0 ? "&" : "?") + "from_rec=1&rank=" + encodeURIComponent(String(pickRank));
    }

    function stockBadgeLabel(tier) {
      if (tier === "in") return "In stock";
      if (tier === "limited") return "Limited — book soon";
      return "Contact us";
    }

    var pickBadge =
      pickRank != null && pickRank <= 3
        ? '<span class="tr-card__badge tr-card__badge--pick">#' +
          pickRank +
          " Top match</span>"
        : "";
    var reasonHtml = buildRecommendationReasonHtml(product.productId);

    var stockBadge = "";
    var stockTier = bestVariant && bestVariant.stockTier;
    if (brandBrowse) {
      if (soldOut) {
        stockBadge = '<span class="tr-card__badge tr-card__badge--oos">Contact us</span>';
      }
    } else if (stockTier) {
      var tierClass =
        stockTier === "in"
          ? "tr-card__badge--match"
          : stockTier === "limited"
            ? "tr-card__badge--low"
            : "tr-card__badge--oos";
      stockBadge =
        '<span class="tr-card__badge ' +
        tierClass +
        '">' +
        escHtml(stockBadgeLabel(stockTier)) +
        (matchedSize && stockTier !== "contact" ? ": " + escHtml(matchedSize) : "") +
        "</span>";
    } else if (soldOut) {
      stockBadge = '<span class="tr-card__badge tr-card__badge--oos">Contact us</span>';
    } else if (matchedSize) {
      stockBadge =
        '<span class="tr-card__badge tr-card__badge--match">In stock: ' + escHtml(matchedSize) + "</span>";
    }

    var priceLabel = "";
    if (brandBrowse) {
      priceLabel =
        sizeCount > 1 || uniqueSizes.length > 1
          ? "From $" + minPrice.toFixed(2)
          : "$" + minPrice.toFixed(2);
    } else {
      priceLabel =
        uniqueSizes.length > 1 ? "From $" + minPrice.toFixed(2) : "$" + minPrice.toFixed(2);
    }
    var setOf4Label = minPrice > 0 ? "$" + (minPrice * 4).toFixed(2) : "";
    var installCaption = brandBrowse ? "" : installCaptionForTireSize(matchedSize);
    var rebateHtml = buildRebateHtml(product.rebate);
    var protectionHtml = buildProtectionHtml(product);

    var badgeWrapHtml =
      stockBadge || pickBadge
        ? '<div class="tr-card__badge-wrap">' + pickBadge + stockBadge + "</div>"
        : "";

    var compareVariant =
      bestVariant || ((product.variants || [])[0] ? (product.variants || [])[0] : null);
    var showCompare = window.SpecrTireCompare && compareVariant;

    var card = document.createElement("article");
    card.className =
      "tr-card" +
      (soldOut ? " tr-card--sold-out" : "") +
      (brandBrowse && soldOut ? " tr-card--sold-out-all" : "");
    card.setAttribute("role", "listitem");

    if (brandBrowse) {
      card.setAttribute(
        "aria-label",
        (product.vendor ? product.vendor + " " : "") +
          (product.title || "Tire") +
          (soldOut ? " (sold out)" : "")
      );
    } else if (matchedSize) {
      card.setAttribute(
        "aria-label",
        product.vendor + " " + product.title + " — " + matchedSize + (soldOut ? " (sold out)" : "")
      );
    }

    card.innerHTML =
      buildTrCardMediaHtml(product, soldOut, badgeWrapHtml) +
      '<div class="tr-card__body">' +
      reasonHtml +
      (product.vendor ? '<p class="tr-card__vendor">' + escHtml(product.vendor) + "</p>" : "") +
      '<p class="tr-card__title">' +
      escHtml(product.title) +
      "</p>" +
      formatCardSizesHtml(uniqueSizes, product) +
      '<div class="tr-card__extras">' +
      installCaption +
      protectionHtml +
      rebateHtml +
      "</div>" +
      '<div class="tr-card__actions">' +
      '<div class="tr-card__pricing">' +
      '<p class="tr-card__price' +
      (soldOut ? " tr-card__price--sold-out" : "") +
      '">' +
      escHtml(priceLabel) +
      "</p>" +
      (setOf4Label
        ? '<p class="tr-card__set-price">Set of 4: ' + escHtml(setOf4Label) + "</p>"
        : "") +
      "</div>" +
      (showCompare ? '<button type="button" class="tr-card__compare">Compare</button>' : "") +
      "</div></div>";

    attachTrCardNavigation(card, href);

    if (showCompare && compareVariant) {
      attachTrCardCompare(card, product, {
        variant: compareVariant,
        href: href,
        matchedSize: matchedSize,
        uniqueSizes: uniqueSizes,
        priceLabel: priceLabel,
        minPrice: minPrice,
      });
    }

    var rebateLink = card.querySelector(".tr-card__rebate-link");
    if (rebateLink) {
      rebateLink.addEventListener("click", function (e) {
        e.stopPropagation();
      });
    }

    return wrapTrGridCard(card);
  }

  function renderAllFacetsFromApi(facets) {
    renderFacetCheckboxes(
      brandFiltersEl,
      brandFieldset,
      (facets && facets.brands) || [],
      "name",
      "name",
      selectedBrands,
      "tr-brand-check"
    );
    renderFacetCheckboxes(
      seasonFiltersEl,
      seasonFieldset,
      (facets && facets.seasons) || [],
      "value",
      "value",
      selectedSeasons,
      "tr-season-check"
    );
    renderFacetCheckboxes(
      protectionFiltersEl,
      protectionFieldset,
      (facets && facets.protectionPrograms) || [],
      "id",
      "label",
      selectedProtectionPrograms,
      "tr-protection-check"
    );
    renderFacetCheckboxes(
      speedFiltersEl,
      speedFieldset,
      (facets && facets.speedRatings) || [],
      "value",
      "value",
      selectedSpeedRatings,
      "tr-speed-check"
    );
    renderFacetCheckboxes(
      vehicleTypeFiltersEl,
      vehicleTypeFieldset,
      (facets && facets.vehicleTypes) || [],
      "value",
      "value",
      selectedVehicleTypes,
      "tr-vehicle-type-check"
    );
    renderFacetCheckboxes(
      loadIndexFiltersEl,
      loadIndexFieldset,
      (facets && facets.loadIndices) || [],
      "value",
      "value",
      selectedLoadIndices,
      "tr-load-index-check"
    );
    var treadwearItems = ((facets && facets.treadwearBuckets) || []).map(function (item) {
      return {
        value: item.value,
        label: TREADWEAR_LABELS[item.value] || item.value,
        count: item.count,
      };
    });
    renderFacetCheckboxes(
      treadwearFiltersEl,
      treadwearFieldset,
      treadwearItems,
      "value",
      "label",
      selectedTreadwearBuckets,
      "tr-treadwear-check"
    );
    renderFacetCheckboxes(
      utqgTractionFiltersEl,
      utqgTractionFieldset,
      (facets && facets.utqgTractions) || [],
      "value",
      "value",
      selectedUtqgTractions,
      "tr-utqg-traction-check"
    );
    renderFacetCheckboxes(
      utqgTempFiltersEl,
      utqgTempFieldset,
      (facets && facets.utqgTemperatures) || [],
      "value",
      "value",
      selectedUtqgTemps,
      "tr-utqg-temp-check"
    );
    setupBooleanToggles(facets);
  }

  function syncFeaturedSortOption() {
    if (!sortEl) return;
    var opt = sortEl.querySelector('option[value="featured"]');
    var hasFeatured = allProducts.some(function (p) {
      return p.featured;
    });
    if (hasFeatured && !opt) {
      opt = document.createElement("option");
      opt.value = "featured";
      opt.textContent = "Featured";
      var rebateOpt = sortEl.querySelector('option[value="rebate_first"]');
      if (rebateOpt && rebateOpt.nextSibling) {
        sortEl.insertBefore(opt, rebateOpt.nextSibling);
      } else {
        sortEl.insertBefore(opt, sortEl.firstChild);
      }
    } else if (!hasFeatured && opt) {
      opt.remove();
      if (sortEl.value === "featured") sortEl.value = "price_asc";
    }
  }

  function renderGrid() {
    if (!gridEl) return;
    gridEl.innerHTML = "";

    var filtered = allProducts.filter(passesFilters);
    updateFacetCounts(filtered);
    var sorted = sortProducts(filtered);

    if (resultCountEl) {
      var total = allProducts.length;
      if (filtered.length === total) {
        resultCountEl.textContent = total + (total === 1 ? " tire" : " tires");
      } else {
        resultCountEl.textContent = filtered.length + " of " + total + " tires";
      }
    }

    if (!sorted.length) {
      hide(gridEl);
      show(emptyEl);
      renderCurationNotice(0);
      if (emptyEl && apiData && apiData.context && apiData.context.type === "vehicle") {
        var lead = emptyEl.querySelector(".tr-empty__lead");
        if (lead) {
          lead.textContent =
            "No tires match your vehicle search. Try an OEM size above or search by tire size.";
        }
      }
      return;
    }

    show(gridEl);
    hide(emptyEl);
    renderCurationNotice(sorted.length);
    var ctx = apiData && apiData.context;
    var staggeredSizes = staggerPairFromContext(ctx);
    sorted.forEach(function (p) {
      if (staggeredSizes) {
        var sv = getStaggeredVariants(p, staggeredSizes[0], staggeredSizes[1]);
        if (sv.front || sv.rear) {
          gridEl.appendChild(renderStaggeredProductCard(p, sv));
          return;
        }
      }
      gridEl.appendChild(renderProductCard(p));
    });

    if (typeof window.applyTireBrandLogos === "function") {
      window.applyTireBrandLogos(gridEl);
    }
  }

  function clearAllFilters() {
    selectedBrands.clear();
    selectedSeasons.clear();
    selectedProtectionPrograms.clear();
    selectedSpeedRatings.clear();
    selectedVehicleTypes.clear();
    selectedLoadIndices.clear();
    selectedTreadwearBuckets.clear();
    selectedUtqgTractions.clear();
    selectedUtqgTemps.clear();
    if (priceMinEl) priceMinEl.value = "";
    if (priceMaxEl) priceMaxEl.value = "";
    if (inStockEl) inStockEl.checked = false;
    if (rebateOnlyEl) rebateOnlyEl.checked = false;
    if (onSaleOnlyEl) onSaleOnlyEl.checked = false;
    if (runFlatOnlyEl) runFlatOnlyEl.checked = false;
    if (studdableOnlyEl) studdableOnlyEl.checked = false;
    if (evOnlyEl) evOnlyEl.checked = false;
    if (oemOnlyEl) oemOnlyEl.checked = false;
    staggerSizeFilter = "all";
    root.querySelectorAll(
      ".tr-brand-check, .tr-season-check, .tr-protection-check, .tr-speed-check, .tr-vehicle-type-check, .tr-load-index-check, .tr-treadwear-check, .tr-utqg-traction-check, .tr-utqg-temp-check"
    ).forEach(function (el) {
      el.checked = false;
    });
    if (apiData && apiData.context) renderOemChooser(apiData.context);
    renderGrid();
    writeUiFiltersToUrl();
  }

  function openFiltersDrawer() {
    lastFocusBeforeDrawer = document.activeElement;
    if (filtersPanel) {
      filtersPanel.classList.add("tr-filters--open");
      filtersPanel.setAttribute("role", "dialog");
      filtersPanel.setAttribute("aria-modal", "true");
      filtersPanel.setAttribute("aria-label", "Filter tires");
    }
    if (overlayEl) {
      show(overlayEl);
      overlayEl.setAttribute("aria-hidden", "false");
    }
    document.body.classList.add("tr-filters-drawer-open");
    if (filtersCloseBtn) filtersCloseBtn.focus();
  }

  function closeFiltersDrawer() {
    if (filtersPanel) {
      filtersPanel.classList.remove("tr-filters--open");
      filtersPanel.removeAttribute("role");
      filtersPanel.removeAttribute("aria-modal");
      filtersPanel.removeAttribute("aria-label");
    }
    if (overlayEl) {
      hide(overlayEl);
      overlayEl.setAttribute("aria-hidden", "true");
    }
    document.body.classList.remove("tr-filters-drawer-open");
    if (lastFocusBeforeDrawer && lastFocusBeforeDrawer.focus) lastFocusBeforeDrawer.focus();
  }

  function updateRefineLink() {
    if (!refineLink) return;
    var params = new URLSearchParams(window.location.search);
    if (params.get("vendor") && !params.get("size") && !params.get("vin") && !params.get("year") && !params.get("vehicleId")) {
      refineLink.href = "/pages/tires#brand";
    } else if (params.get("vin") || params.get("year") || params.get("vehicleId")) {
      refineLink.href = "/pages/tires#vehicle";
    } else {
      refineLink.href = "/pages/tires";
    }
  }

  function bindBooleanFilter(input) {
    if (!input) return;
    input.addEventListener("change", function () {
      renderGrid();
      writeUiFiltersToUrl();
    });
  }

  function loadResults(retryCount) {
    retryCount = retryCount || 0;
    readUiFiltersFromUrl();
    var apiUrl = buildApiUrl();
    updateRefineLink();

    if (!apiUrl) {
      setError("No search criteria. Use the tire finder to search by size, brand, or vehicle.");
      hide(loadingEl);
      show(emptyEl);
      return;
    }

    setError("");
    show(loadingEl);
    show(skeletonEl);
    hide(emptyEl);
    hide(gridEl);
    if (gridEl) gridEl.innerHTML = "";

    fetch(apiUrl, { method: "GET", headers: { Accept: "application/json" }, cache: "no-store" })
      .then(function (res) {
        return res
          .text()
          .then(function (text) {
            var data = {};
            if (text) {
              try {
                data = JSON.parse(text);
              } catch (e) {
                if (!res.ok) {
                  throw new Error("Server error (" + res.status + "). Please try again.");
                }
                throw new Error("Invalid response from tire search.");
              }
            }
            return { ok: res.ok, status: res.status, data: data };
          });
      })
      .then(function (out) {
        if (!out.ok && out.status >= 500 && retryCount < 1) {
          setTimeout(function () {
            loadResults(retryCount + 1);
          }, 1500);
          return;
        }
        hide(loadingEl);
        hide(skeletonEl);
        var data = out.data || {};
        if (!out.ok || data.error) {
          setError(
            data.error ||
              (out.status >= 500
                ? "Tire search is temporarily unavailable. Please try again."
                : "Could not load tire results.")
          );
          show(emptyEl);
          return;
        }

        apiData = data;
        allProducts = data.products || [];
        initialFacets = data.facets || null;
        syncStaggerSizeContext(data.context);
        renderContextBanner(data.context);
        applySizeSeoMeta(data.context);
        setupPriceInputs(data.facets);
        renderAllFacetsFromApi(data.facets);

        if (!allProducts.length) {
          hide(gridEl);
          show(emptyEl);
          if (resultCountEl) resultCountEl.textContent = "0 tires";
          return;
        }

        syncFeaturedSortOption();
        persistTireSearchContextForChat();
        renderGrid();
        trackEvent("tire_results_view", {
          result_count: allProducts.length,
          context_type: (data.context && data.context.type) || "unknown",
        });
        scheduleLoadRecommendations();
      })
      .catch(function (err) {
        hide(loadingEl);
        hide(skeletonEl);
        setError(
          (err && err.message) || "Network error. Check your connection and try again."
        );
        show(emptyEl);
      });
  }

  if (sortEl) {
    sortEl.addEventListener("change", function () {
      renderGrid();
      writeUiFiltersToUrl();
    });
  }
  if (priceMinEl) {
    priceMinEl.addEventListener("input", debouncedRenderGrid);
    priceMinEl.addEventListener("change", debouncedRenderGrid);
  }
  if (priceMaxEl) {
    priceMaxEl.addEventListener("input", debouncedRenderGrid);
    priceMaxEl.addEventListener("change", debouncedRenderGrid);
  }
  if (inStockEl) {
    inStockEl.addEventListener("change", function () {
      renderGrid();
      writeUiFiltersToUrl();
    });
  }
  bindBooleanFilter(rebateOnlyEl);
  bindBooleanFilter(onSaleOnlyEl);
  bindBooleanFilter(runFlatOnlyEl);
  bindBooleanFilter(studdableOnlyEl);
  bindBooleanFilter(evOnlyEl);
  bindBooleanFilter(oemOnlyEl);
  if (clearFiltersBtn) clearFiltersBtn.addEventListener("click", clearAllFilters);
  if (filtersOpenBtn) filtersOpenBtn.addEventListener("click", openFiltersDrawer);
  if (filtersCloseBtn) filtersCloseBtn.addEventListener("click", closeFiltersDrawer);
  if (overlayEl) overlayEl.addEventListener("click", closeFiltersDrawer);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && filtersPanel && filtersPanel.classList.contains("tr-filters--open")) {
      closeFiltersDrawer();
    }
  });

  function initPage() {
    syncProfileFromUrl();
    loadResults();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initPage);
  } else {
    initPage();
  }
})();
